<template>
  <div>
    <!-- pc -->
    <div class="header" v-show="this.isApp == true ? false : true">
      <div class="language">
        <div class="language_choice subb" @click="changeLange">
          {{ $t("nav.Language") }}
        </div>
        <div class="change_lange subb" v-show="isLange">
          <div class="sjx"></div>
          <div class="lange_con">
            <div @click="switchZh" class="lange_item">中文</div>
            <div @click="switchEn" class="lange_item">English</div>
            <div @click="switchPt" class="lange_item">Português</div>
            <div @click="switchEs" class="lange_item">Español</div>

          </div>
        </div>
      </div>
      <div class="heading-wrap">
        <h2>
          <div class="logoTiger" @click="goIndex"><img src="../assets/index/tigerLogo.png" alt="" class="subb logoImg">
          </div>
        </h2>
      </div>
      <div class="login">
        <div class="login_left subb">
          <div class="maintain" @click="test">
            <div class="maintain_sub">{{ $t("nav.maintain") }}</div>
            <span>{{ $t("nav.time") }}</span>
          </div>
        </div>
        <div class="right_con">
          <div v-show="hasLogin == 0 ? true : false">
            <div class="sign-info opacity-show">
              <div class="sign-account"><span></span>
                <div class="user_msg">{{ userName }}</div>
              </div>
              <div class="sign-currency"><span></span>
                <div class="user_msg">{{ chip }}</div>
              </div>
            </div>
          </div>
          <div class="login_right subb">
            <div class="login_button">
              <button v-show="hasLogin == '1' ? true : false" type="button" class="button_login subb" @click="showLogin">
                {{ $t("nav.login") }}
              </button>
              <button v-show="hasLogin == '0' ? true : false" type="button" class="button_login subb" @click="loginOut">
                {{ $t("login.loginSub") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="banner subb">
        <div :class="
          this.isActiveIndex == true ? 'banner_index_active' : 'banner_index'
        " @click="changIndexColor()">
          <img class="banner_index_img" src="../assets/index/icon-home.png" />
        </div>
        <!-- 头部标题 -->
        <div class="footerBanner" v-for="(item, index) in bannerList" :key="index" @click="goPage(index)">

          <div :class="
            isActive == index
              ? 'footerBanner_list_choice'
              : 'footerBanner_list'
          " @mouseover="changeChoice(index)" @mouseout="removeChoice(index)" @click="changeColor(index)">
            {{ item.title }}
          </div>
        </div>
        <div id="shiyixa" style="height: 1.25rem"></div>
      </div>
    </div>
    <!-- H5 -->
    <div class="h5-content" v-show="this.isApp == false ? false : true">
      <div class="isApp_content">
        <div class="isApp_top">
          <div class="isApp_top_left">
            <div class="isApp_list" @click="openList">
              <i class="el-icon-s-unfold"></i>
            </div>
            <div class="isApp_language">
              <div class="language_choice subb" @click="changeLange">
                {{ $t("nav.Language") }}
              </div>
              <div class="isApp_change_lange subb" v-show="isLange">
                <div class="sjx"></div>
                <div class="lange_con">
                  <div @click="switchZh" class="lange_item">中文</div>
                  <div @click="switchEn" class="lange_item">English</div>
                  <div @click="switchPt" class="lange_item">Português</div>
                  <div @click="switchEs" class="lange_item">Español</div>

                </div>
              </div>
            </div>
          </div>
          <div class="right_con">
            <div v-show="hasLogin == 0 ? true : false">
              <div class="isapp_sign-info opacity-show">
                <div class="isapp_sign-account"><span></span>
                  <div class="user_msg">{{ userName }}</div>
                </div>
                <div class="isapp_sign-currency"><span></span>
                  <div class="user_msg">{{ chip }}</div>
                </div>
              </div>
            </div>
            <div class="isApp_top_right">
              <button v-show="hasLogin == '1' ? true : false" type="button" class="isApp_login subb" @click="showLogin">
                {{ $t("nav.login") }}
              </button>
              <button v-show="hasLogin == '0' ? true : false" type="button" class="isApp_login subb" @click="loginOut">
                {{ $t("login.loginSub") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="appList" v-show="isOpen">
        <div class="appList_top">
          <div class="appList_top_pad">
            <div @click="closeList"><i class="el-icon-close"></i></div>
            <div>{{ $t("nav.menu") }}</div>
            <div class="h5Zan"></div>
          </div>
        </div>
        <div>
          <div class="appList_item" v-for="(item, index) in appBannerList" :key="index" @click="goAppList(index)">
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
    <Login-pop ref="LoginPop"></Login-pop>
    <router-view></router-view>
  </div>
</template>

<script>
// import LoginPop from '../components/loginPop'
import { mapActions, mapState, mapMutations } from "vuex";
import "../assets/h5/header.css";
export default {
  // components: {LoginPop},
  data() {
    return {
      // isLogin:false,
      isLange: false,
      showPopup: false,
      lange: "语言",
      isChoice: 0,
      isOpen: false,
    };
  },
  watch: {
  },
  created() {
  },
  mounted() {
    // this.aa()
    document.addEventListener("click", (e) => {
      if (e.target.className != "language_choice subb") {
        this.isLange = false;
      }
    });

    // this.$refs.isActivity.isShowAte = false
  },
  computed: {
    // 头部标题list
    bannerList() {
      return [
        {
          title: this.$t("nav.teach"),
        },
        {
          title: this.$t("nav.buy"),
        },
        {
          title: this.$t("nav.gift"),
        },
        {
          title: this.$t("nav.vip"),
        },
        {
          title: this.$t("nav.paihang"),
        },
        {
          title: this.$t("nav.kefu"),
        },

        {
          title: this.$t("nav.game"),
        },
      ];
    },
    appBannerList() {
      return [
        {
          title: this.$t("nav.Homepage"),
        },
        {
          title: this.$t("nav.buy"),
        },
        {
          title: this.$t("nav.News"),
        },
        {
          title: this.$t("nav.Downloads"),
        },
        {
          title: this.$t("nav.Member"),
        },
        {
          title: this.$t("nav.gift"),
        },
        {
          title: this.$t("nav.teach"),
        },
        {
          title: this.$t("nav.kefu"),
        },
        {
          title: this.$t("nav.paihang"),
        },
        {
          title: this.$t("nav.official"),
        },
        {
          title: this.$t("nav.game"),
        },
      ];
    },
    ...mapState({
      isActive(state) {
        return state.active;
      },
      isActiveIndex(state) {
        return state.activeIndex;
      },
      hasLogin(state) {
        return state.hasLogin;
      },
      isApp(state) {
        return state.isApp;
      },
      userName(state) {
        return state.userName;
      },
      chip(state) {
        return state.chip;
      },
    }),
  },
  methods: {
    ...mapMutations(['logout']),
    test() {
      // console.log('hasLogin',this.hasLogin)
      // console.log('isLogin',this.isLogin)
    },
    goIndex() {
      this.$router.push("/")
      this.$store.commit("setActive", -1);
      this.$store.commit("setShow", true);
    },
    changeChoice(index) {
      this.isChoice = index;
    },
    removeChoice(index) {
      this.isChoice = -1;
    },
    changeColor(index) {
      this.active = index;
      this.activeIndex = false;
      this.$store.commit("setActive", this.active);
      this.$store.commit("setShow", this.activeIndex);
      // console.log("this.activeIndex", this.activeIndex);
    },
    changIndexColor() {
      this.activeIndex = true;
      this.active = -1;
      this.$store.commit("setActive", this.active);
      this.$store.commit("setShow", this.activeIndex);
      // console.log("this.activeIndex", this.activeIndex);
      this.$router.push("/");
    },
    switchZh() {
      //中文
      this._i18n.locale = "zh";
      // localStorage.setItem("lang", "zh");
      this.lange = "中文";
      location.reload();
      localStorage.setItem("lang", "zh");
    },
    switchEn() {
      //英文
      // console.log('en')
      this._i18n.locale = "en";
      // localStorage.setItem("lang", "en");
      this.lange = "English";
      location.reload();
      localStorage.setItem("lang", "en");
    },
    switchPt() {
      //葡萄牙
      // console.log('en')
      this._i18n.locale = "pt";
      // localStorage.setItem("lang", "en");
      this.lange = "Português";
      location.reload();
      localStorage.setItem("lang", "pt");
    },
    switchEs() {
      //西班牙
      // console.log('en')
      this._i18n.locale = "es";
      // localStorage.setItem("lang", "en");
      this.lange = "Español";
      location.reload();
      localStorage.setItem("lang", "es");
    },



    goPage(index) {
      // console.log("pageindex", index);
      if (index == 0) {
        this.$router.push("/Teaching");
      }
      if (index == 1 && this.hasLogin != "0") {
        this.$refs.LoginPop.showLogin();
        this.$store.commit("setActive", -1);
      }
      if (index == 1 && this.hasLogin == "0") {
        this.$router.push("/Buy");
      }
      if (index == 2 && this.hasLogin != "0") {
        this.$refs.LoginPop.showLogin();
        this.$store.commit("setActive", -1);
      }
      if (index == 2 && this.hasLogin == "0") {
        this.$router.push("/Gift");
      }
      if (index == 3 && this.hasLogin != "0") {
        this.$refs.LoginPop.showLogin();
        this.$store.commit("setActive", -1);
      }
      if (index == 3 && this.hasLogin == "0") {
        this.$router.push("/Vip");
      }
      if (index == 4) {
        this.$router.push("/Leader");
      }
      if (index == 5) {
        this.$router.push("/Client");
      }
      if (index == 6) {
        this.$router.push("/Game");
      }
    },
    goAppList(index) {
      this.isOpen = false;
      // console.log("goAppList", index);
      if (index == 0) {
        this.$router.push("/");
      }
      if (index == 1 && this.hasLogin != "0") {
        // console.log('---123---')
        this.$refs.LoginPop.showLogin();
      }
      if (index == 1 && this.hasLogin == "0") {
        this.$router.push("/Buy");
      }
      if (index == 2) {
        this.$router.push("/");
        this.$nextTick(() => {
          var news = document.getElementsByClassName("isapp_news")[0].offsetTop;
          window.scrollTo({ top: news, behavior: "smooth" });
        });
      }
      if (index == 3) {
        this.$router.push("/");
        this.$nextTick(() => {
          var downloadHeight =
            document.getElementsByClassName("qrcode-wrap")[0].offsetTop;
          window.scrollTo({ top: downloadHeight, behavior: "smooth" });
        });
      }
      if (index == 4 && this.hasLogin != "0") {
        this.$refs.LoginPop.showLogin();
      }
      if (index == 4 && this.hasLogin == "0") {
        this.$router.push("/Vip");
      }
      if (index == 5 && this.hasLogin != "0") {
        this.$refs.LoginPop.showLogin();
      }
      if (index == 5 && this.hasLogin == "0") {
        this.$router.push("/Gift");
      }
      if (index == 6) {
        this.$router.push("/Teaching");
      }
      if (index == 7) {
        this.$router.push("/Client");
      }
      if (index == 8) {
        this.$router.push("/Leader");
      }
      if (index == 9) {
        this.$router.push("/");
        this.$nextTick(() => {
          let footer =
            document.getElementsByClassName("isapp_footer_main")[0].offsetTop;
          window.scrollTo({ top: footer, behavior: "smooth" });
        });
      }

      if (index == 10) {
        this.$router.push("/Game");
      }
    },
    showLogin() {
      this.$refs.LoginPop.showLogin();
    },
    changeLange() {
      this.isLange = !this.isLange;
    },
    openList() {
      // console.log("this.appBannerList", this.appBannerList);
      this.isOpen = true;
    },
    closeList() {
      this.isOpen = false;
    },
    loginOut() {
      this.logout()
    }
  },
};
</script>

<style lang="less" scoped="">
.header {
  // background-color: black;
  height: 6.25rem;
  width: 75rem;
  margin: 0 auto;
}

.language {
  position: fixed;
  text-align: left;
  right: -0.9375rem;
  margin-top: 0.625rem;
  float: right;
  margin-right: -1.25rem;
  transition: all 0.5s ease-out;
}

.language:hover {
  margin-top: 0.625rem;
  float: right;
  // text-align: center;
  margin-right: 0rem;
  transition: all 0.5s ease-out;
}

.language_choice {
  width: 4.375rem;
  border: 0.0625rem solid rgb(216, 130, 0);
  background: rgb(216, 130, 0);
  padding: 0.3125rem;
  border-radius: 0.3125rem;
  color: white;
}

.heading-wrap {
  display: block;
}

.heading-wrap h2 {
  display: block;
  margin: 0 auto;
}

.heading-wrap h2 a {
  background: url("https://www.jinjinjin777.com/static/images/en/logo-goldenlucky.png") no-repeat;
  background-size: 100% auto;
  display: block;
  margin: 0 auto;
  max-width: 31.375rem;
  padding-bottom: 22%;
  width: 40%;
}

.login {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: -5rem;
  align-items: center;
  margin-bottom: 0.3125rem;

  .login_left {
    border: 0.0625rem solid rgb(216, 130, 0);
    background: rgb(57, 18, 8);
    width: 14.5625rem;
    // height: 3.75rem;
    padding: 0.625rem 0.625rem;
    text-align: left;
    border-radius: 0.3125rem;

    .maintain div {
      color: #f1e35e;
      margin-right: 0.625rem;
      margin-bottom: 0.0625rem;
    }

    .maintain span {
      color: white;
      font-weight: 500;
    }
  }

  .login_right {}
}

.banner_index {
  width: 30%;
  height: 3.5625rem;
}

.footerBanner:hover {
  background-image: linear-gradient(180deg, #f7d13a, #cf9822 50%, #e29315);
}

.banner_index:hover {
  background-image: linear-gradient(180deg, #f7d13a, #cf9822 50%, #e29315);
}

.banner {
  height: 3.5625rem;
  width: 100%;
  background-image: linear-gradient(180deg, #f6d34b, #eeb841 50%, #e6a132);
  border-bottom: solid 0.1875rem #fccf1d;
  border-radius: 0.3125rem;
  display: flex;
  flex-direction: row;

  // border: 0.0625rem solid black;
  .banner_index_img {
    height: 2.5rem;
    width: 2.5rem;
    margin-top: 0.3125rem;
  }

  .banner_index_active {
    width: 30%;
    height: 3.5625rem;
    background-image: linear-gradient(155deg, #f1ffa7, #dbff16 8%, transparent 30%), linear-gradient(180deg, #8eec71, #6fcb0a 50%, #4dc303 50%, #3a8a08);
  }

  .footerBanner {
    color: black;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 70%;

    .footerBanner_list {
      width: 100%;
      border: 0.0313rem solid #d88e29;
      line-height: 3.5625rem;
      font-size: 1.25rem;
      font-weight: 600;
    }

    .footerBanner_list_choice {
      width: 100%;
      border: 0.0313rem solid #d88e29;
      background-image: linear-gradient(155deg, #f1ffa7, #dbff16 8%, transparent 30%), linear-gradient(180deg, #8eec71, #6fcb0a 50%, #4dc303 50%, #3a8a08);
      line-height: 3.5625rem;
      font-size: 1.25rem;
      font-weight: 600;
    }
  }
}

.login_pop {
  position: relative;
  position: fixed;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 25rem;
  height: 15.625rem;
  background-color: black;
  border: 0.125rem solid #e1aa3f;
  border-radius: 0.3125rem;
}

.login_title {
  background: #ffdb6b;
  background-image: linear-gradient(180deg,
      #dea339 0%,
      #f9cc4a 20%,
      #ffdb6b 35%,
      #ffdb6b 55%,
      #ce9631 80%,
      #8c5c0d 100%);
  color: #2e0100;
  font-weight: 700;
  font-size: 1.25rem;
  height: 2.25rem;
  line-height: 2.25rem;
}

.login_msg {
  width: 23.75rem;
  background-color: rgb(60, 0, 0);
  height: 12.5rem;
  margin: 0 auto;
}

.login_com {
  padding-top: 1.875rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.login_as {
  color: #f9cc4a;
  margin-right: 0.625rem;
}

.login_input input {
  height: 1.875rem;
  width: 12.5rem;
}

.login_in {
  color: #000;
  background-image: linear-gradient(#d5ff70 0%,
      #3b8c00 50%,
      #358000 50%,
      #296100 90%,
      #1e4600 100%);
  border: 0.125rem solid #a2750a;
  font-size: 1.125rem;
  padding: 0.375rem 0rem;
  font-weight: 600;
  width: 9.375rem;
  margin: 0 auto;
  margin-top: 1.25rem;
  border-radius: 0.3125rem;
}

.login_guanbi {
  position: absolute;
  top: -0.9375rem;
  right: -0.9375rem;

  .el-icon-error {
    font-size: 2.1875rem;
  }
}

.change_lange {
  color: white;
  border: 0.0625rem solid rgb(216, 130, 0);
  background-color: rgba(216, 130, 0, 0.788);
  margin-top: 0.9375rem;
  position: relative;
  border-radius: 0.3125rem;
}

.sjx {
  position: absolute;
  width: 0.0063rem;
  height: 0.0063rem;
  border-bottom: 0.3125rem solid rgba(216, 130, 0, 0.788);
  border-top: 0.3125rem solid transparent;
  border-left: 0.3125rem solid transparent;
  border-right: 0.3125rem solid transparent;
  top: -0.625rem;
  left: 0.625rem;
}

.lange_con {
  padding: 0.625rem;
}

.lange_item {
  padding: 0.3125rem 0;
  border-bottom: 0.0625rem solid rgb(134, 84, 9);
}

.isapp {
  height: 6.25rem;
  width: 75rem;
  margin: 0 auto;
  background: red;
}

.right_con {
  display: flex;
  flex-direction: row;
  // align-items: center;
}

.sign-info {
  background: rgba(0, 0, 0, .6);
  height: 4.125rem;
  // margin-top: -0.625rem;
  padding: 0.1875rem 0.3125rem;
  width: 9.375rem;
  border-radius: 0.625rem;
  margin-right: 1.25rem;
}

.isapp_sign-info {
  background: rgba(0, 0, 0, .6);
  height: 2.5rem;
  // margin-top: -0.625rem;
  padding: 0.1875rem 0.3125rem;
  width: 6.25rem;
  border-radius: 0.3125rem;
  margin-right: 0.2rem;
}

.user_msg {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 0.3125rem;
}

.sign-account {
  color: #fff;
  display: flex;
  align-items: center;
}

.isapp_sign-account {
  color: #fff;
  display: flex;
  align-items: center;
}

.sign-account span {
  background: url("../assets/index/icon-member.png") center center no-repeat;
  // background-size: 3.125rem 3.125rem;
  background-size: 140% 140%;
  width: 1.875rem;
  height: 1.875rem;
  margin-left: 0.3125rem;
}

.isapp_sign-account span {
  background: url("../assets/index/icon-member.png") center center no-repeat;
  // background-size: 3.125rem 3.125rem;
  background-size: 140% 140%;
  width: 1.25rem;
  height: 1.25rem;
}

.sign-currency {
  color: #fff;
  display: flex;
  align-items: center;
}

.isapp_sign-currency {
  color: #fff;
  display: flex;
  align-items: center;
}

.sign-currency span {
  background: url("../assets/index/icon-coin.png") center center no-repeat;
  background-size: 140% 140%;
  width: 1.875rem;
  height: 1.875rem;
  margin-left: 0.25rem;
}

.isapp_sign-currency span {
  background: url("../assets/index/icon-coin.png") center center no-repeat;
  background-size: 140% 140%;
  width: 1.25rem;
  height: 1.25rem;
}

.logoTiger img {
  width: 30rem;
  height: 16.5rem;
}

.button_login {
  width: 6.25rem;
  height: 3rem;
  border-radius: 0.625rem;
  font-size: 1.375rem;
  font-family: inherit;
  border: none;
  position: relative;
  overflow: hidden;
  z-index: 1;
  color: #ffffff;
  background-color: red;
  box-shadow: 6px 6px 12px #e45f5f,
    -6px -6px 12px #b14f4f;
  border: 1px solid rgb(240, 38, 38);
}

.button_login:before {
  content: '';
  width: 0;
  height: 3rem;
  border-radius: 0.625rem;
  position: absolute;
  top: 0;
  left: 0;
  background-image: linear-gradient(to right, #f374a9 0%, rgb(199, 12, 12) 100%);
  transition: .5s ease;
  display: block;
  z-index: -1;
}

.button_login:hover::before {
  width: 6.25rem;
}
</style>

